import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  bannersWrapper: {
    paddingTop: '32px'
  }
});
export default useStyles;